import React from 'react'

import { faBooks } from '@fortawesome/pro-light-svg-icons/faBooks'
import { faCog } from '@fortawesome/pro-light-svg-icons/faCog'
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons/faQuestionCircle'
import { faSignOut } from '@fortawesome/pro-light-svg-icons/faSignOut'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import url from '../../../constants/routes'

import styles from './UserEntry.scss'

const UserEntry = ({ logoutCb }) => {
    const userData = [
        {
            name: 'account',
            displayName: 'My Profile',
            hasUrl: true,
            url: '/user/account',
            target: '_self',
            icon: faCog
        },
        {
            name: 'helpcenter',
            displayName: 'Help Center',
            hasUrl: true,
            url: url.helpCenter(),
            target: '_blank',
            rel: 'noopener noreferrer',
            icon: faQuestionCircle
        },
        {
            name: 'resources',
            displayName: 'Resources',
            hasUrl: true,
            url: '/resources/library',
            target: '_blank',
            rel: 'noopener noreferrer',
            icon: faBooks
        },
        {
            name: 'logout',
            displayName: 'Logout',
            hasUrl: false,
            cbfn: logoutCb,
            icon: faSignOut
        }
    ]

    return (
        <div className={styles.entry}>
            <ul data-cy="userInfoActions" className={styles.list}>
                {userData.map(elem => {
                    return (
                        <li data-cy={elem.name} key={elem.name}>
                            {elem.hasUrl ? (
                                <a href={elem.url} target={elem.target} rel={elem.rel}>
                                    <FontAwesomeIcon size="lg" icon={elem.icon} />
                                    {elem.displayName}
                                </a>
                            ) : (
                                <a onClick={elem.cbfn}>
                                    <FontAwesomeIcon size="lg" icon={elem.icon} />
                                    {elem.displayName}
                                </a>
                            )}
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default UserEntry
